import { proximaApi } from '../proximaApi'
import { type ChangeAccumulationCurrencyPayload } from '../schema-dtos/AccumulationCurrencyInstructionPayloadDtos'

const SUB_URL = '/asset-holdings/asset-holders'

export const accumulationCurrencyInstructionApi = proximaApi.injectEndpoints({
  endpoints: (builder) => ({

    updateAccumulationCurrencyInstruction: builder.mutation<undefined, Partial<ChangeAccumulationCurrencyPayload>>({
      query: (payload: ChangeAccumulationCurrencyPayload) => ({
        url: `${SUB_URL}/${payload.assetHolderId}/accumulation-currency-instructions/project/${payload.projectId}`,
        method: 'PUT',
        body: payload
      }),
      invalidatesTags: ['Dashboard']
    })
  })
})

export const useUpdateAccumulationCurrencyMutation = accumulationCurrencyInstructionApi.endpoints.updateAccumulationCurrencyInstruction.useMutation
